<template>
  <div :style="{ width: width + 'px', height: height + 'px' }">
    <el-card class="qianming-container" body-style="padding:0px">
      <!---vue-esign组件-->
      <vue-esign
        ref="esign"
        :width="width"
        :height="height"
        :isCrop="isCrop"
        :lineWidth="lineWidth"
        :lineColor="lineColor"
        :format="'image/png'"
        :bgColor.sync="bgColor"
      ></vue-esign>
      <div class="contro-container">
        <el-button type="danger" @click="handleReset">清空画板</el-button>
        <el-button type="primary" @click="handleGenerate">确认签名</el-button>
        <div class="bottm-box"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
// 引入组件
import vueEsign from "vue-esign";
// 这个是请求文件路径的接口
// import fileService from '@/api/file/fileService.js'
export default {
  components: { vueEsign },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Sign",
  data() {
    return {
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      isCrop: false,
      height: undefined,
      width: window.innerWidth,
      // 设备类型
      deviceType: "",
    };
  },
  created() {
    this.detectDeviceType();
    console.log("device", this.deviceType);
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    detectDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        this.deviceType = "Windows Phone";
      } else if (/android/i.test(userAgent)) {
        this.deviceType = "Android";
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.deviceType = "iOS";
      } else {
        this.deviceType = "Desktop";
        this.height = window.innerWidth / 2;
      }
    },
    // 清空画板..
    handleReset() {
      this.$refs.esign.reset();
    },
    // 生成签名图片..
    handleGenerate() {
      this.$refs["esign"]
        .generate()
        .then((res) => {
          // 得到了签字生成的base64图片
          // console.log('resultImg', this.resultImg)
          // 这里直接传base64到父组件，然后在父组件处理数据调用接口
          // this.$emit('setsignin', res)
          // 也可以转换成在线地址
          const bl = this.dataURLtoFile(res);
          let formData = new FormData();
          formData.append("file", bl, `sign${Date.now()}.png`);

          this.$emit("setsignin", formData);
        })
        .catch(() => {
          this.$message.error("未签名！");
        });
    },
    // 将base64转成blob流
    dataURLtoFile(urlData) {
      const type = "image/png";
      let bytes = null;
      if (urlData.split(",").length > 1) {
        bytes = window.atob(urlData.split(",")[1]);
      } else {
        bytes = window.atob(urlData);
      }
      let ab = new ArrayBuffer(bytes.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type });
    },
  },
};
</script>

<style scoped>
button {
  height: 40px;
}

.contro-container {
  flex-wrap: wrap;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background-color: #d3d3d3;
  position: absolute;
  bottom: 0px;
}
.bottm-box {
  width: 100%;
  height: 20px;
}
.qianming-container {
  width: 100vw;
  height: 350px;
  margin: auto;
  position: relative;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 95%;
  margin-left: 2.5%;
  margin-top: 20px;
}
</style>
